import React from 'react';
import { isEmpty } from 'lodash';
import { PropTypes } from 'prop-types';
import { Button, Icons } from 'sarsaparilla';
import { errorsToStringList } from '../../src/utils/utils';

const propTypes = {
  errorHeader: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      error: PropTypes.string
    })
  ])),
  isInline: PropTypes.bool,
  clear: PropTypes.func,
  className: PropTypes.string
};

export default class ErrorNotification extends React.Component {
  constructor(props) {
    super(props);
    this.renderErrors = this.renderErrors.bind(this);
  }

  renderErrors() {
    const { errorHeader, errors, isInline, clear, className } = this.props;
    const errorsList = errorsToStringList(errors);
    const header = errorHeader || 'Errors:';

    if (!isEmpty(errorsList)) {
      return (
        <div className={className}>
          <div className="rec-notification-error permit-error-notification">
            <span className="rec-notification-icon">
              <Icons.IconError className="rec-icon-error" />
            </span>
            {
              errorsList.length === 1 ?
                (
                  <div className="rec-notification-body">
                    <div className={isInline ? "rec-notification-title-single-row" : "rec-notification-title"}>
                      {header}
                    </div>
                    <p>
                      {errorsList[0]}
                    </p>
                  </div>
                ) :
                (
                  <div className="rec-notification-body">
                    <div className="rec-notification-title" id="header">{header}</div>
                    <ul>
                      {errorsList.map((err) => <li key={err}>{err}</li>)}
                    </ul>
                  </div>
                )
            }
            {!!clear && (
              <Button
                appearance="subtle"
                size="sm"
                iconBeforeElement={<Icons.IconClose />}
                screenReaderTextBefore="Close the error notification"
                onClick={clear}
                className="rec-notification-close" />
            )}
          </div>
        </div>
      );
    }

    return null;
  }

  render() {
    // If errors array is undefined, or every element in errors array is undefined
    if (!this.props.errors || this.props.errors.every((elem) => elem === undefined)) {
      return null;
    }

    return (
      <div className="permit-notifications-errs">{this.renderErrors()}</div>
    );
  }
}

ErrorNotification.propTypes = propTypes;
